import React, { memo, HTMLProps } from 'react'
import uuid from 'uuid/v4'

export interface IToggleProps extends HTMLProps<HTMLInputElement> {
  dataTest?: string
  label: string
}

/**
 * Toggle element with label.  Allows toggling state by clicking on label
 */
/** @deprecated consider using Switch instead */
export const Toggle = memo<IToggleProps>(
  ({ dataTest, id = uuid(), label, className = '', ...props }) => (
    <label htmlFor={id} className={`flex items-center ${className}`}>
      <input type='checkbox' id={id} className='switch' data-test={dataTest} {...props} />
      <span className='ml1'>{label}</span>
    </label>
  )
)

export default Toggle
